import authInstance from "../Interceptor/interceptor";

export const fetchOrganizationsEffect = (page, pagesize, pagination_required) => {
  return authInstance.get(`/organizations/organizationGetAll?pageNo=${page}&pagesize=${pagesize}&pagination_required=${pagination_required}`);
};

export const fetchOrganizationByIdEffect = (id) => {
  return authInstance.get(`/organizations/getOrganization?organization_id=${id}`);
};

export const addOrganizationEffect = (userData) => {
  return authInstance.post("/organizations/insertOrganization", userData);
};

export const updateOrganizationEffect = (id, userData) => {
  return authInstance.put(`/organizations/updateOrganization/${id}`, userData);
};

export const deleteOrganizationEffect = (id) => {
  return authInstance.delete(`/organizations/deleteOrganization/${id}`);
};
